import store from "@/store";

import i18n from "@/i18n";
import { bus } from '@/utils/event-bus';
/* eslint-disable */
import { spreadDataHandler } from "@/utils/financialBkoForm/formMapperHandler";
import { useFinancialNationality, } from "@/enums/financials/financialNationality";

const COMPLEX_TABS = ["spreadsData", "insuranceData", "nominalInterestRateData", "credencialsAPIData"];
import router from "@/router";
import { PAGES } from "@/enums/pages";

const SPREAD_RATE_TYPE = {
    0: {
        rateType: 'Fixa',
        addOrRemove: '+',
    },
    1: {
        rateType: 'Indexada',
        addOrRemove: '+',
    }
}

const SPREAD_PERIODICITY = {
    12: "Anual",
    6: "Semestral"
}

const SPREAD_PERIODICITY_MAP = {
    "Anual": 12,
    "Semestral": 6
}

const VEHICLE_STATUS = {
    "Novo": 'N',
    "Usado": 'U'
}

async function setPostalCodeHandler(form, changeAction, countryField, key, value) {
    if (changeAction.type === "fetchPostalCodeDataAddress") {
        const cpExt = form.fields.find((f) => f?.key?.startsWith("cpExt"));

        const district = form.fields.find((f) => f?.key?.startsWith("district"));
        let cp4 = form.fields.find((f) => f?.key?.startsWith("cp4"));

        if (changeAction.typeOfPostalCode === "PT" && countryField?.value !== 'ES') {
            //! PT código postal - é enviado no formulário o cp4 e cp3
            const cp3 = form.fields.find((f) => f?.key?.startsWith("cp3"));
            if (value) {
                if (key.startsWith("cp4")) {
                    cp4.value = value;
                } else if (key.startsWith("cp3")) {
                    cp3.value = value;
                }
            }

            const cp4Value = cp4?.value?.toString();
            const cp3Value = cp3?.value?.toString();
            // Verifica se foi atingido o limite dos caracteres de ambos os campos para fazer a pesquisa do código postal
            if (cp4Value.length === 4 && cp3?.maxLength === cp3Value.length) {
                const postalCodeValue = cp4Value + cp3Value;
                const {districtValue} = await store.dispatch("FinancialsBkoFormModule/getSearchByPostalCode", {
                    formNationality: "PT",
                    localityFieldKey: cpExt.key,
                    postalCode: postalCodeValue
                });
                // Colocar este campo com o tipo de dropdown
                store.commit("FinancialsBkoFormModule/setFieldAttribute", {
                    key: cpExt?.key,
                    attribute: 'type',
                    value: "dropdown"
                });

                //Distrito
                district.value = districtValue;
                district.editable = !districtValue;
                district.hasError = false;
                //Cidade
                cpExt.loading = false;
                cp4.hasError = false;

                const cityValues = store.getters["FinancialsBkoFormModule/getSearchByPostalCode"](cpExt.key);
                if (cityValues.length > 1) {
                    if (cityValues.length === 2) {
                        cityValues[1].selected = true;

                        // Create a promise to handle the asynchronous update
                        const updateAddress1CityValue = new Promise((resolve) => {
                            resolve(cityValues[1]?.text);
                        });

                        // Update cpExt.value when the promise is resolved
                        updateAddress1CityValue.then((updatedValue) => {
                            cpExt.value = updatedValue;
                            console.log(cityValues[1]?.text, cpExt.value);
                        });
                    }
                    store.commit("FinancialsBkoFormModule/setFieldAttribute", {
                        key: cpExt?.key,
                        attribute: 'options',
                        value: cityValues
                    });
                    store.commit("FinancialsBkoFormModule/setFieldValue", cpExt);
                    store.commit("FinancialsBkoFormModule/setIncrementField", {key: cpExt?.key});
                } else {
                    cpExt.type = "text";
                }
            } else {
                //Distrito
                district.value = "";
                district.editable = true;

                //Cidade
                cpExt.value = "";
                store.commit("FinancialsBkoFormModule/setFieldAttribute", {
                    key: cpExt?.key,
                    attribute: 'options',
                    value: []
                });
                // Colocar este campo com o tipo de text
                store.commit("FinancialsBkoFormModule/setFieldAttribute", {
                    key: cpExt?.key,
                    attribute: 'type',
                    value: "text"
                });
                cpExt.loading = true;
                store.commit("FinancialsBkoFormModule/setIncrementField", {key: cpExt?.key});
            }
        } else {
            //! ES código postal - apenas é enviado no formulário o cp4
            if (value) {
                if (key.startsWith("cp4")) {
                    cp4.value = value;
                }
            }

            const cp4Value = cp4?.value?.toString();
            console.log('cp4Value: ' + cp4Value)
            //if (cp4?.maxLength === value?.length) {
            if (value?.length >= 4 && value?.length <= 5) {
                const {districtValue} = await store.dispatch("FinancialsBkoFormModule/getSearchByPostalCode", {
                    formNationality: "ES",
                    localityFieldKey: cpExt.key,
                    postalCode: value
                });

                // Colocar este campo com o tipo de dropdown
                store.commit("FinancialsBkoFormModule/setFieldAttribute", {
                    key: cpExt?.key,
                    attribute: 'type',
                    value: "dropdown"
                });
                //Distrito
                district.value = districtValue;
                district.editable = !districtValue;
                district.hasError = false;
                //Cidade
                cpExt.loading = false;
                cp4.hasError = false;

                const cityValues = store.getters["FinancialsBkoFormModule/getSearchByPostalCode"](cpExt.key);

                if (cityValues.length > 1) {
                    if (cityValues.length === 2) {
                        cityValues[1].selected = true;

                        // Create a promise to handle the asynchronous update
                        const updateAddress1CityValue = new Promise((resolve) => {
                            resolve(cityValues[1]?.text);
                        });

                        // Update cpExt.value when the promise is resolved
                        updateAddress1CityValue.then((updatedValue) => {
                            cpExt.value = updatedValue;
                            console.log(cityValues[1]?.text, cpExt.value);
                        });
                    }
                    store.commit("FinancialsBkoFormModule/setFieldAttribute", {
                        key: cpExt?.key,
                        attribute: 'options',
                        value: cityValues
                    });
                    store.commit("FinancialsBkoFormModule/setFieldValue", cpExt);
                    store.commit("FinancialsBkoFormModule/setIncrementField", {key: cpExt?.key});
                } else {
                    cpExt.type = "text";
                }
            } else {
                //Distrito
                district.value = "";
                district.editable = true;
                //Cidade
                cpExt.value = "";
                store.commit("FinancialsBkoFormModule/setFieldAttribute", {
                    key: cpExt?.key,
                    attribute: 'options',
                    value: []
                });
                // Colocar este campo com o tipo de text
                store.commit("FinancialsBkoFormModule/setFieldAttribute", {
                    key: cpExt?.key,
                    attribute: 'type',
                    value: "text"
                });
                cpExt.loading = true;
                store.commit("FinancialsBkoFormModule/setIncrementField", {key: cpExt?.key});
            }
            cp4.value = value;
        }
    }
}

function dataStartHandler(spreadsData, dateStartField) {

    if (!spreadsData) {
        return;
    }

    const createUniqueArray = (data, key) => {
        const set = new Set();

        data?.forEach((element) => {
            const value = element.split("||")[key];
            set.add(value);
        });

        return [...set].sort();
    };

    const formatArray = (arr) => [
        {
            value: -1,
            text: i18n.t("dropdownSelection"),
            disabled: true,
        },
        ...arr.map(item => ({
            value: item,
            text: item, 
        })),
    ];

    // Create formatted arrays
    const formattedDateStartArray = formatArray(createUniqueArray(spreadsData, 4), 'dateStart');
    // Commit to the store
    store.commit("FinancialsBkoFormModule/setSpreadsFilters", {key: 'dateStartArray', arr: formattedDateStartArray});

    store.commit("FinancialsBkoFormModule/setSpreadFieldAttribute", { key: dateStartField?.key, attribute: 'options', value: formattedDateStartArray });
    //store.commit("FinancialsBkoFormModule/setFieldValue", dateStartField);
    store.commit("FinancialsBkoFormModule/setIncrementField", { key: dateStartField?.key });
}

function setTableSpreadsHandler(activeTab, formFields = {}, isToClearFilter) {
    const spreadData = store.getters['FinancialsBkoFormModule/getSpreadData'];

    const spreadFiltersArr = [];
    const tableComponent = activeTab?.form?.find((form) => form?.sectionId === 3)?.fields[0];
    const spreadInputFields = activeTab?.form?.find((form) => form?.sectionId === 2)?.fields;
    let isEditable = true;

    if(isToClearFilter == 1 || isToClearFilter == true) {
        isEditable = false;
        tableComponent.showTables = false;
        spreadInputFields.map((field) => field.fieldShow = false);
        activeTab.btns = [
            {
                "key": "goBack",
                "bgColor": "#FBA139",
                "label": "Voltar",
                "icon": "chevron-left",
                "iconPosition": "",
                "class": "btn-2"
            }
        ];
        spreadDataHandler(spreadData);
    }

    formFields.map((obj) => spreadFiltersArr.push(obj.value));

    const allFilled = spreadFiltersArr.every((element) => element !== "");

    const dateStartField = formFields.find((f) => f?.key?.startsWith("dateStartArray"));

    const keyToFindFilter = spreadFiltersArr.slice(0, -1).join("||");
    const spreadDataFilter = Object.keys(spreadData).filter(k => k.startsWith(keyToFindFilter + '||'));
    dataStartHandler(spreadDataFilter, dateStartField);

    if (!allFilled) {
        return;
    } else {
        const keyToFind = spreadFiltersArr.join("||");
        const spreadFound = spreadData[keyToFind] || {};

        tableComponent.data = [
            {
                id: 1,
                tableTitle: 'Valores para Spread (Fixa)',
                rateType: 'Fixa',
                addOrRemove: '+',
                tableData: spreadFound['addSpreadsFixed']
            },
            {
                id: 2,
                tableTitle: 'Valores para Spread (Indexada)',
                rateType: 'Indexada',
                addOrRemove: '+',
                tableData: spreadFound['addSpreadsIndexed']
            }
        ];

        tableComponent.showTables = !spreadFound?.addSpreadsFixed ? false : true;
        spreadInputFields.map((field) => field.fieldShow = field.key !== 'id');

        if(!spreadFound?.addSpreadsFixed) {
            spreadInputFields.map((field) => field.fieldShow = false);
        }

        spreadInputFields.map((field) => {
            switch (field.key) {
                case "id":
                    field.value = spreadFound['id'];
                    break;
                case "maxMonths":
                    field.value = spreadFound['maxMonths'];
                    break;
                case "maxYears":
                    field.value = spreadFound['maxYears'];
                    break;
                case "minMonths":
                    field.value = spreadFound['minMonths'];
                    break;
                case "dateStart":
                    field.value = spreadFound['dtStart'];
                    field.hasError = false;
                    break;
                case "periodicity":
                    field.value = SPREAD_PERIODICITY[spreadFound['periodicity']];
                    break;
            }

            isEditable = !spreadFound?.addSpreadsFixed ? false : field.editable;
        });

        tableComponent.editable = isEditable;

        if (isEditable) {
            activeTab.btns = [
                {
                    "key": "goBack",
                    "bgColor": "#FBA139",
                    "label": "Voltar",
                    "icon": "chevron-left",
                    "iconPosition": "",
                    "class": "btn-2"
                },
                {
                    "key": "onDeleteSpreads",
                    "bgColor": "#ff0000",
                    "label": "Apagar Taxa",
                    "icon": "fa-trash",
                    "iconPosition": "right",
                    "class": "btn-2 ml-2"
                },
                {
                    "key": "onSaveSpreads",
                    "bgColor": "#008BCD",
                    "label": "Guardar",
                    "icon": "",
                    "iconPosition": "",
                    "class": "btn-2"
                }
            ];
        } else {
            activeTab.btns = [
                {
                    "key": "goBack",
                    "bgColor": "#FBA139",
                    "label": "Voltar",
                    "icon": "chevron-left",
                    "iconPosition": "",
                    "class": "btn-2"
                }
            ];
        }
    }
}

async function setInsuranceTable(activeTab, formFields) {
    const routeParams = router.currentRoute.params;
    const financeId = routeParams.id;
    const idInstance = routeParams.idInstance || store.getters["FinancialsBkoFormModule/getIdInstance"];

    const insurranceArr = formFields.find((field) => field.key === "insuranceArr");
    const entityCompanyArr = formFields.find((field) => field.key === "entityCompany");
    const dateStartArr = formFields.find((field) => field.key === "dateStartArray");

    const insurranceArrSelected = insurranceArr.options.find((option) => option.selected);
    const entityCompanyArrSelected = entityCompanyArr.options.find((option) => option.selected);
    const dateStartArrSelected = dateStartArr.options.find((option) => option.selected);

    const coeficientComponent = activeTab?.form?.find((form) => form?.sectionId === 2);
    const tableComponent = activeTab?.form?.find((form) => form?.sectionId === 2)?.fields[0];
    const comissionsComponent = activeTab?.form?.find((form) => form?.sectionId === 4);
    const tableComissions = activeTab?.form?.find((form) => form?.sectionId === 4)?.fields[0];
    tableComponent.data = [];
    tableComissions.data = [];

    if (!insurranceArrSelected || !entityCompanyArrSelected || !dateStartArrSelected 
        || dateStartArrSelected?.value == ''
    ) {
        tableComponent.showTables = false;
        //tableComissions.showTables = false;
        return;
    }

    tableComissions.fieldShow = true;

    const isEditRoute = router.currentRoute.name == PAGES.BACKOFFICE_FINANCIAL_DETAIL_EDIT;
    let isEditable = routeParams.toEdit === undefined && !isEditRoute ? false : routeParams.toEdit || isEditRoute;

    const insuranceData = await store.dispatch("FinancialsBkoFormModule/getInsuranceData", {
        idFinancial: financeId,
        idInstance: idInstance,
        idEntityCompany: entityCompanyArrSelected.text === 'Todas' ? -1 : entityCompanyArrSelected.value,
        idInsurance: insurranceArrSelected.id,
        dtStart: !dateStartArrSelected ? null : dateStartArrSelected?.value,
    }) || {};

    const cleanedInsuranceData = Object.keys(insuranceData).reduce((acc, key) => {
        if (Object.keys(insuranceData[key]).length > 0) {
            acc[key] = insuranceData[key];
        }
        return acc;
    }, {});

    const tableTitlesMapper = {
        "coeficientsNew": "Valores coeficientes (Novos)",
        "coeficientsUsed": "Valores coeficientes (Usados)"
    }

    if (cleanedInsuranceData) {
        const neoCoeficientsObj = Object.keys(cleanedInsuranceData).reduce((acc1, keyParent1) => {
            acc1[keyParent1] = Object.keys(cleanedInsuranceData[keyParent1]).reduce((acc2, keyParent2) => {
                acc2[keyParent2] = Object.keys(cleanedInsuranceData[keyParent1][keyParent2]).reduce((acc3, keyParent3) => {
                    acc3[keyParent3] = cleanedInsuranceData[keyParent1][keyParent2][keyParent3]?.amount;
                    return acc3;
                }, {});
                return acc2;
            }, {});
            return acc1;
        }, {});

        Object.keys(neoCoeficientsObj).forEach((key, index) => {
            tableComponent.data.push({
                id: index,
                tableTitle: tableTitlesMapper[key],
                tableData: neoCoeficientsObj[key]
            });
        });

        tableComponent.showTables = true;
    }

    const tableTitlesComissionMapper = {
        "coeficientsNew": "Valores comissões (Novos)",
        "coeficientsUsed": "Valores comissões (Usados)"
    }

    if (cleanedInsuranceData) {
        const neoCoeficientsObj = Object.keys(cleanedInsuranceData).reduce((acc1, keyParent1) => {
            acc1[keyParent1] = Object.keys(cleanedInsuranceData[keyParent1]).reduce((acc2, keyParent2) => {
                acc2[keyParent2] = Object.keys(cleanedInsuranceData[keyParent1][keyParent2]).reduce((acc3, keyParent3) => {
                    acc3[keyParent3] = cleanedInsuranceData[keyParent1][keyParent2][keyParent3]?.comission;
                    return acc3;
                }, {});
                return acc2;
            }, {});
            return acc1;
        }, {});

        Object.keys(neoCoeficientsObj).forEach((key, index) => {
            tableComissions.data.push({
                id: index,
                tableTitle: tableTitlesComissionMapper[key],
                tableData: neoCoeficientsObj[key]
            });
        });

        tableComissions.showTables = true;
    }

    coeficientComponent.label = "Coeficientes";
    coeficientComponent.isCollapsable = true;
    coeficientComponent.isCollapsed = true;
    comissionsComponent.label = "Comissões";

    if (isEditable) {
        activeTab.btns = [
            {
                "key": "goBack",
                "bgColor": "#FBA139",
                "label": "Voltar",
                "icon": "chevron-left",
                "iconPosition": "",
                "class": "btn-2"
            },
            {
                "key": "onSaveCoeficients",
                "bgColor": "#008BCD",
                "label": "Guardar",
                "icon": "save",
                "iconPosition": "",
                "class": "btn-2"
            }
        ];
    }
}

async function setInsuranceRatesTable(activeTab, formFields) {
    const routeParams = router.currentRoute.params;
    const financeId = routeParams.id;
    const idInstance = routeParams.idInstance || store.getters["FinancialsBkoFormModule/getIdInstance"];

    const insuranceArr = formFields.find((field) => field.key === "insuranceArr");
    const insuranceArrSelected = insuranceArr.options.find((option) => option.selected);
    const coefficientComponent = activeTab?.form?.find((form) => form?.sectionId === 2)?.fields[0];
    const labelComponent = activeTab?.form?.find((form) => form?.sectionId === 5);
    const tableComponent = activeTab?.form?.find((form) => form?.sectionId === 5)?.fields[0];

    //let isEditable = routeParams.toEdit === undefined ? false : routeParams.toEdit;

    const insuranceData = await store.dispatch("FinancialsBkoFormModule/getInsuranceData", {
        idFinancial: financeId,
        idInstance: idInstance,
        idInsurance: insuranceArrSelected.id,
        idEntityCompany: -1
    });

    await store.commit("FinancialsBkoFormModule/setFinancialInsuranceRatesData", insuranceData);

    tableComponent.fieldShow = true;
    coefficientComponent.fieldShow = false;
    labelComponent.isCollapsed = false;

}

export function isFinancial(country = "PT") {
    const routeParams = router.currentRoute.params;
    const financeId = routeParams.id;
    //const ptFinancialMapper = financialNationalityMap.find((financialMapper) => financialMapper.nationality === country);
    //return ptFinancialMapper.financialIds.includes(Number(financeId));

    return useFinancialNationality("PT")?.includes(Number(financeId)) || false;
}

async function setRateSalesmanDataHandler(activeTab, formFields = {}) {
    const isPTFinancial = isFinancial();

    const rateSalesmanData = store.getters['FinancialsBkoFormModule/getRatesSalesmanData'];
    
    let rateSalesmanFiltersArr = [];
    const rateSalesmanInputFieldsNew = activeTab?.form?.find((form) => form?.sectionId === 2)?.fields;
    const rateSalesmanInputFieldsUsed = activeTab?.form?.find((form) => form?.sectionId === 4)?.fields;

    formFields.map((obj) => rateSalesmanFiltersArr.push(obj.valueOptionSelected ? obj.valueOptionSelected : obj.value));
    rateSalesmanFiltersArr = rateSalesmanFiltersArr.map(val => {
        if (val === 'Novo'){
            return 'N';
        } else if (val === 'Usado') {
            return 'U';
        } else {
            return val; // if value doesn't match 'Novo' or 'Usado', return original value
        }
    });

    if(isPTFinancial) {
        rateSalesmanFiltersArr = rateSalesmanFiltersArr.slice(0, -2);
    }

    const allFilled = rateSalesmanFiltersArr.every((element) => element !== "");

    if (!allFilled) {
        return;
    } else {
        const keyToFind = rateSalesmanFiltersArr.join("||");
        //const keyToFindDefault = rateSalesmanFiltersArr[0] + "||0";
        const rateSalesmanFoundNew = rateSalesmanData[keyToFind + "||N"] || {};
        const rateSalesmanFoundUsed = rateSalesmanData[keyToFind + "||U"] || {};
        
        rateSalesmanInputFieldsNew.map((field) => {
            switch (field.key) {
                case "greenValueNew":
                    field.value = rateSalesmanFoundNew['greenValue'] || '';
                    break;
                case "yellowValueNew":
                    field.value = rateSalesmanFoundNew['yellowValue'] || '';
                    break;
                case "redValueNew":
                    field.value = rateSalesmanFoundNew['redValue'] || '';
                    break;
                case "idProduct":
                    field.value = rateSalesmanFoundNew['idProduct'] || 0;
                    break;
            }
        });
        rateSalesmanInputFieldsUsed.map((field) => {
            switch (field.key) {
                case "greenValueUsed":
                    field.value = rateSalesmanFoundUsed['greenValue'] || '';
                    break;
                case "yellowValueUsed":
                    field.value = rateSalesmanFoundUsed['yellowValue'] || '';
                    break;
                case "redValueUsed":
                    field.value = rateSalesmanFoundUsed['redValue'] || '';
                    break;
                case "idProduct":
                    field.value = rateSalesmanFoundUsed['idProduct'] || 0;
                    break;
            }
        });
    }
}

export async function setNominalRatesDataHandler(activeTab, formFields = {}) {
    const isPTFinancial = isFinancial();

    const tableComponent = activeTab?.form?.find((form) => form?.sectionId === 3)?.fields[0];
    const tableComponentUsed = activeTab?.form?.find((form) => form?.sectionId === 3)?.fields[1];
    const nominalRatesData = store.getters['FinancialsBkoFormModule/getNominalRatesData'];

    let rateFiltersArr = [];

    let dataStartFilter = '';
    formFields.map((obj) =>  {
        if(obj?.key !== 'productRate' && obj?.key !== 'dateStartArray') {
            rateFiltersArr.push(obj.valueOptionSelected ? obj.valueOptionSelected : obj.value)
        }

        if(obj?.key === 'dateStartArray' && obj?.value !== '') {
            dataStartFilter = obj?.value || '';
        }
    });

    if(isPTFinancial) {
        rateFiltersArr = rateFiltersArr.slice(0, -1);
    }
        
    const allFilled = rateFiltersArr.every((element) => element !== "");
    if (!allFilled) {
        return;
    } else {
        const keyToFind = rateFiltersArr.slice(0, -1).join("||");
        const keyNew = keyToFind + '||N||';

        const nominalRatesFound = nominalRatesData?.['N'] || [];
        tableComponent.data = nominalRatesDataHandler(nominalRatesFound, keyNew, dataStartFilter);
        //console.log('nominalRatesFound: ', keyNew)
        const keyUsed = keyToFind + '||U||';
        const nominalRatesFoundUsed = nominalRatesData?.['U'] || [];
        tableComponentUsed.data = nominalRatesDataHandler(nominalRatesFoundUsed, keyUsed, dataStartFilter);
    }

}

export function getFormFields(activeTab) {
    let formFields = [];
    formFields = activeTab?.form?.find((form) => form?.sectionId === 1)?.fields
    return formFields
}

export function nominalRatesDataHandler(nominalRatesData, keyToFind, dataStartFilter) {
    const tinSallemanData = store.getters['FinancialsBkoFormModule/getTinsSalesmanData'];

    const data = dataStartFilter == '' 
                    ? nominalRatesData
                    : nominalRatesData?.filter(tin => tin.dtStart == dataStartFilter) || [];

    return nominalRatesData = data?.map((nominalRate, index) => {
        const tin = (nominalRate?.tin % 1 === 0) ? (nominalRate?.tin + ".0") : (nominalRate?.tin.toString());
        const key = keyToFind + tin;
        const isAvailable = key in tinSallemanData ? 'S' : 'N'; 

        return {
            ...nominalRate,
            isAvailableForSalesman: isAvailable,
        }
    });
}

export function setFieldValueHandler(state, onChangeActions, value, key) {
    let nationalityField;

    if (COMPLEX_TABS.includes(state?.activeTab?.key)) {
        let fieldFounded = {};
        let formFields = [];

        state.activeTab?.form?.forEach((form) => {
            form?.fields?.forEach((field) => {
                if (field.key === key) {
                    fieldFounded = field;
                    formFields = form.fields;
                }
            });
        });

        switch (fieldFounded?.type) {

            case "dropdown":
                fieldFounded.value = fieldFounded?.valueText ? value?.text : value?.value;
                fieldFounded.valueOptionSelected = value?.value;
                break;
            case "table":
                fieldFounded.data = value;
                break;
            case "nominal-rate":
                console.log('fieldFounded:: ', fieldFounded)
                break;
            default:
                fieldFounded.value = value;
                break;
        }

        const checkIfAllFieldsAreFilled = (formFields) => {
            const fieldsArr = [];
            formFields.map((obj) => {
                if (obj.fields) fieldsArr.push(obj.value);
            });

            return fieldsArr.every((element) => element !== "");
        };

        if (onChangeActions) {
            onChangeActions?.map(async (changeAction) => {
                switch (changeAction.type) {
                    case 'setTableSpreads':
                        if (checkIfAllFieldsAreFilled(formFields)) setTableSpreadsHandler(state.activeTab, formFields, false);
                        break;
                    case 'setInsuranceTable':
                        if (checkIfAllFieldsAreFilled(formFields)) {
                            if (isFinancial("PT")) {
                                await setInsuranceRatesTable(state.activeTab, formFields);
                            } else {
                                await setInsuranceTable(state.activeTab, formFields);
                            }
                        }
                        break;
                    case 'addNewSpread':
                        bus.$emit('addNewSpread');
                        break;
                    case 'setSellerRates':
                        if (checkIfAllFieldsAreFilled(formFields)) await setRateSalesmanDataHandler(state.activeTab, formFields);
                        await setNominalRatesDataHandler(state.activeTab, formFields);
                        break;
                    case 'saveSalesmanRate':
                        bus.$emit('saveSalesmanRate');
                        break;
                }
                        
            });
        }
    } else {
        state?.activeTab?.form?.forEach((form) => {
            form?.fields?.map((field) => {
                field.hasError = field?.required ? field?.hasError : false;
                return field
            })

            if (onChangeActions) {
                onChangeActions?.map(async (changeAction) => {
                    if (changeAction.type === "changeCountry" && form?.sectionId == 1) {
                        nationalityField = form?.fields?.find((f) => f?.key?.startsWith("nationality"));

                        if (value?.value) {
                            nationalityField.value = value?.value;

                            let cp3Field = form.fields.find((f) => f?.key?.startsWith("cp3"));
                            cp3Field.fieldShow = true;
                            let districtField = form.fields.find((f) => f?.key?.startsWith("district"));
                            districtField.colspan = 3;
                            if (value?.value === 'ES') {
                                cp3Field.fieldShow = false;
                                districtField.colspan = 5;
                            }
                        }
                    }

                    if (form?.sectionId == 1) {
                        nationalityField = form?.fields?.find((f) => f?.key?.startsWith("nationality"));

                        await setPostalCodeHandler(form, changeAction, nationalityField, key, value);
                    }

                    if (changeAction.type === "changeCountry" && form?.sectionId == 2) {
                        const nationality = nationalityField;
                        nationality.value = value?.value;

                        const technicalContactPhoneField = form?.fields?.find((f) => f?.key === "technicalContactPhone");
                        technicalContactPhoneField.prefixValue = nationality?.value === "PT" ? "+351" : "+34";

                        const technicalContactGsmField = form?.fields?.find((f) => f?.key === "technicalContactGsm");
                        technicalContactGsmField.prefixValue = nationality?.value === "PT" ? "+351" : "+34";
                    }

                    if (changeAction.type === "changeCountry" && form?.sectionId == 3) {
                        const nationality = nationalityField;
                        nationality.value = value?.value;

                        const comercialContactPhoneField = form?.fields?.find((f) => f?.key === "comercialContactPhone");
                        comercialContactPhoneField.prefixValue = nationality?.value === "PT" ? "+351" : "+34";

                        const comercialContactGsmField = form?.fields?.find((f) => f?.key === "comercialContactGsm");
                        comercialContactGsmField.prefixValue = nationality?.value === "PT" ? "+351" : "+34";
                    }

                    if(changeAction.type === "saveExpensesFinance_TaxStampFinance" && form?.sectionId == 0) {
                        bus.$emit('saveExpensesFinance_TaxStampFinance');
                    }

                    if(changeAction.type === "saveExternalService_DealerCommission" && form?.sectionId == 7) {
                        bus.$emit('saveExternalService_DealerCommission');
                    }

                });
            }

            let field = form.fields.find((f) => f.key === key);

            if (field && field.type !== "dropdown") {
                field.value = value;
                field.hasError = false;
            }

            if (field && field.type === "dropdown") {
                //field.value = value?.value;
                field.hasError = false;
            }

            /*if (field && field.type === "dropdown" && field.key === "expensesFinanced") {
                console.log('setFieldValueHandler:: ', key, value, onChangeActions);
                field.value = field?.valueText ? value?.text : value?.value;
                field.valueOptionSelected = value?.value;

                field.hasError = false;
            }*/

            if (field && value && field.type === "dropdown") {
                field.hasError = false;
            }

        });
    }
}

export function setSpreadFieldValueHandler(state, { key, value, changeAction, onChangeActions, options, }) {
    options;
    changeAction;

    state?.spreadsForm?.form?.forEach((form) => {
        const field = form.fields.find((f) => f.key === key);
        
        if (onChangeActions) {
            onChangeActions.map(async (changeAction) => {
                if (changeAction.type === "changeCountry") {
                    if (value?.value) {
                        console.info(value?.value);
                    }   
                }
            });
        } else {
            if (field) {
                if (field.type !== "dropdown") {
                    field.value = value;
                }

                if (field.type === "dropdown") {
                    field.value = value?.text;
                }
                
                field.hasError = false;
            }
        }
    });
}

export function onSaveSpreads(activeTab, idFinancial) {
    const spreadFilters = activeTab.form.find((form) => form?.sectionId === 1)?.fields;
    const spreadInputFields = activeTab.form.find((form) => form?.sectionId === 2)?.fields;
    const spreadData = activeTab.form.find((form) => form?.sectionId === 3)?.fields[0].data;

    let payload = spreadsDataMapper(spreadData);

    return {
        idFinancialRate: spreadInputFields.find((field) => field?.key === "id")?.value,

        idFinancial: idFinancial,
        idEntityCompany: Number(spreadFilters.find((field) => field?.key === "companyArray")?.value),
        brand: spreadFilters.find((field) => field?.key === "brandArray")?.value,
        idClientType: Number(spreadFilters.find((field) => field?.key === "clientTypeArray")?.value),
        idProduct: spreadFilters.find((field) => field?.key === "productArray")?.value,
        dtStartOld: spreadFilters.find((field) => field?.key === "dateStartArray")?.value,
        
        dtStart: spreadInputFields.find((field) => field?.key === "dateStart")?.value,
        minMonths: spreadInputFields.find((field) => field?.key === "minMonths")?.value,
        maxMonths: spreadInputFields.find((field) => field?.key === "maxMonths")?.value,
        maxYears: spreadInputFields.find((field) => field?.key === "maxYears")?.value,
        periodicity: Number(SPREAD_PERIODICITY_MAP[spreadInputFields.find((field) => field?.key === "periodicity")?.value]),
        spreadData: payload
    };
}

export function onDeleteSpreads(activeTab, idFinancial) {
    const spreadFilters = activeTab.form.find((form) => form?.sectionId === 1)?.fields;
    const spreadInputFields = activeTab.form.find((form) => form?.sectionId === 2)?.fields;

    return {
        idFinancialRate: spreadInputFields.find((field) => field?.key === "id")?.value,
        idFinancial: idFinancial,
        idEntitycompany: Number(spreadFilters.find((field) => field?.key === "companyArray")?.value),
        brand: spreadFilters.find((field) => field?.key === "brandArray")?.value,
        idClientType: Number(spreadFilters.find((field) => field?.key === "clientTypeArray")?.value),
        idProduct: spreadFilters.find((field) => field?.key === "productArray")?.value,
        periodicity: Number(SPREAD_PERIODICITY_MAP[spreadInputFields.find((field) => field?.key === "periodicity")?.value]),
        dtStart: spreadFilters.find((field) => field?.key === "dateStartArray")?.value,
    };
}

export function onCleanSpreadsFilters(activeTab) {

    let formFields = [];
    activeTab?.form?.forEach((form) => {
        form?.fields?.forEach((field) => {
            if (field.key === "companyArray" || field.key === "clientTypeArray" 
                || field.key === "productArray" || field.key === "brandArray" 
                || field.key === "dateStartArray"
            ) {
                if (field.key === "dateStartArray") {
                    field.value = '';
                }
                formFields = form.fields;
            }
            
            if (!(field.key === "companyArray" || field.key === "clientTypeArray" 
                || field.key === "productArray" || field.key === "brandArray")
            ) {
                field.value = '';
            }
        });
    });
           
    setTableSpreadsHandler(activeTab, formFields, true);

}

const spreadsDataMapper = (spreadData) => {
    const spreads = [];

    const spreadsData = (data, rateType, addOrRemove) => {
        let yearNameKeys = Object.keys(data);
        yearNameKeys?.map((yearName) => {
            let monthKeys = Object.keys(data[yearName]);
            monthKeys?.map((month) => {
                spreads.push(oSpread(rateType, yearName, month, addOrRemove, data[yearName][month]));
            })
        })  
    }

    spreadData?.map((data, index) => {
        const { rateType, addOrRemove, tableData } = data;
        if (tableData !== undefined) {
            spreadsData(tableData, rateType, addOrRemove);
        } else {
            const { rateType, addOrRemove } = SPREAD_RATE_TYPE[index];
            spreadsData(data, rateType, addOrRemove);
        }
    });

    return spreads;
}

const oSpread = (rateType, yearName, month, addOrRemove, value) => {
    return {
        rateType: rateType,
        yearName: yearName,
        month: Number(month),
        addOrRemove: addOrRemove,
        value: Number(value)
    }
}


export function onSaveCoeficients(activeTab, insuranceData) {
    const cleanedInsuranceData = Object.keys(insuranceData).reduce((acc, key) => {
        if (Object.keys(insuranceData[key]).length > 0) {
            acc[key] = insuranceData[key];
        }
        return acc;
    }, {});
    const forms = activeTab.form;

    const coeficientsNew = forms[2].fields[0].data[0]?.tableData === undefined ? forms[2].fields[0].data[0] : forms[2].fields[0].data[0]?.tableData;
    const coeficientsUsed = forms[2].fields[0].data[1]?.tableData === undefined ? forms[2].fields[0].data[1] : forms[2].fields[0].data[1]?.tableData;
    const comissionsNew = forms[3].fields[0].data[0]?.tableData === undefined ? forms[3].fields[0].data[0] : forms[3].fields[0].data[0]?.tableData;
    const comissionsUsed = forms[3].fields[0].data[1]?.tableData === undefined ? forms[3].fields[0].data[1] : forms[3].fields[0].data[1]?.tableData;

    let coeficients = [];

    Object.keys(cleanedInsuranceData?.coeficientsNew || {})?.forEach(key => {
        Object.keys(cleanedInsuranceData?.coeficientsNew[key])?.forEach(period => {
            coeficients.push({
                idTin : cleanedInsuranceData.coeficientsNew[key][period].idTin,
                tin : cleanedInsuranceData.coeficientsNew[key][period].tin,
                vehicleType: "N",
                period : Number(period),
                amount : coeficientsNew[key][period],
                comission : comissionsNew[key][period]
            });
            
        })
    });

    Object.keys(cleanedInsuranceData?.coeficientsUsed || {})?.forEach(key => {
        Object.keys(cleanedInsuranceData?.coeficientsUsed[key])?.forEach(period => {
            coeficients.push({
                idTin : cleanedInsuranceData.coeficientsUsed[key][period].idTin,
                tin : cleanedInsuranceData.coeficientsUsed[key][period].tin,
                vehicleType: "U",
                period : Number(period),
                amount : coeficientsUsed[key][period],
                comission : comissionsUsed[key][period]
            });
            
        })
    });

    let response = { coeficients : coeficients}
    return response;
}

export function onSaveSalesmanRate(activeTab) {
    // const isESFinancial = isFinancial("ES");

    const nominalRateFilters = activeTab.form.find((form) => form?.sectionId === 1)?.fields;
    const nominalRateInputFieldsNew = activeTab.form.find((form) => form?.sectionId === 2)?.fields;
    const nominalRateInputFieldsUsed = activeTab.form.find((form) => form?.sectionId === 4)?.fields;
    const companyField = nominalRateFilters.find((field) => field?.key === "companies");
    const productField = nominalRateFilters.find((field) => field?.key === "productRate");

    const company = companyField?.valueOptionSelected ? companyField?.valueOptionSelected : companyField?.value
    const product = productField?.valueOptionSelected ? productField?.valueOptionSelected : productField?.value

    const greenFieldNew = nominalRateInputFieldsNew.find((field) => field?.key === "greenValueNew");
    const yellowFieldNew = nominalRateInputFieldsNew.find((field) => field?.key === "yellowValueNew");
    const redFieldNew = nominalRateInputFieldsNew.find((field) => field?.key === "redValueNew");
    const greenFieldUsed = nominalRateInputFieldsUsed.find((field) => field?.key === "greenValueUsed");
    const yellowFieldUsed = nominalRateInputFieldsUsed.find((field) => field?.key === "yellowValueUsed");
    const redFieldUsed = nominalRateInputFieldsUsed.find((field) => field?.key === "redValueUsed");

    let ratesSalesmanNew = {
        greenValue: Number(greenFieldNew?.value),
        yellowValue: Number(yellowFieldNew?.value),
        redValue: Number(redFieldNew?.value)
    };

    let ratesSalesmanUsed = {
        greenValue: Number(greenFieldUsed?.value),
        yellowValue: Number(yellowFieldUsed?.value),
        redValue: Number(redFieldUsed?.value)
    };

    // if(isESFinancial) {
    //     greenValue = greenField?.valueOptionSelected ? greenField?.valueOptionSelected : greenField?.value?.value
    //     yellowValue = yellowField?.valueOptionSelected ? yellowField?.valueOptionSelected : yellowField?.value?.value
    //     redValue = redField?.valueOptionSelected ? redField?.valueOptionSelected : redField?.value?.value
    // }

    return {
        idEntityCompany: Number(company),
        ratesSalesmanNew: ratesSalesmanNew,
        ratesSalesmanUsed: ratesSalesmanUsed,
        idProduct: Number(product)
    };
}

export const onOperationFinancialTin = (propsEl, financialId, activeTab) => {
    const idFinancial = isNaN(propsEl.row.idFinancial) ? financialId : propsEl.row.idFinancial;
    const availableForSalesman = (Number(propsEl.row.isAvailableForSalesman) == 1 || propsEl.row.isAvailableForSalesman == 'S') ? 'S' : 'N';
    
    const moninalRateFilters = activeTab.form.find((form) => form?.sectionId === 1)?.fields;
    const companyField = moninalRateFilters.find((field) => field?.key === "companies")
    const idEntityCompany = companyField.valueOptionSelected ? companyField.valueOptionSelected : companyField.value;

    return {
      id: Number(propsEl.row.id),
      idFinancial: idFinancial,
      tin: {
        id: Number(propsEl.row.idTin),
        percentage: Number(propsEl.row.tin)
      },
      idEntityCompany: Number(idEntityCompany),
      vehicleType: propsEl.row.vehicleType,
      isAvailableForSalesman: availableForSalesman,
      financialCode: propsEl.row.financialCode,
      dtStart: propsEl.row.dtStart || null,
    }
}  

export function onSaveExpensesAndTaxStampFinance(activeTab) {
    const financeData = activeTab.form.find((form) => form?.sectionId === 0)?.fields;

    const expensesFinancedField = financeData.find((field) => field?.key === "expensesFinanced");
    const expensesFinanced = expensesFinancedField.options?.find(option => option.selected)?.value;
    
    const taxFinancedField = financeData.find((field) => field?.key === "taxFinanced");
    const taxFinanced = taxFinancedField?.options?.find(option => option.selected)?.value;

    const legalizationExpensesField = financeData.find((field) => field?.key === "legalizationExpenses");

    const recognitionCommitteeField = financeData.find((field) => field?.key === "recognitionCommittee");
    const reserveExtinctionCostField = financeData.find((field) => field?.key === "reserveExtinctionCost");

    const extraExpensesForTAEGField = financeData.find((field) => field?.key === "extraExpensesForTAEG");

    return {
        expensesFinance: Number(expensesFinanced),
        taxStampFinance: Number(taxFinanced),
        expensesLegalisation: Number(legalizationExpensesField?.value),
        recognitionCommittee: Number(recognitionCommitteeField?.value),
        reserveExtinctionCost: Number(reserveExtinctionCostField?.value),
        extraExpensesForTAEG: Number(extraExpensesForTAEGField?.value)
    };
}

export function onSaveDealerCommission(activeTab) {
    const financeData = activeTab.form.find((form) => form?.sectionId === 7)?.fields;

    const dealerCommissionPercentNewCarField = financeData.find((field) => field?.key === "dealerCommissionPercentNewCar");
    const dealerCommissionPercentUsedCarField = financeData.find((field) => field?.key === "dealerCommissionPercentUsedCar");

    return {
        dealerCommissionPercentNewCar: Number(dealerCommissionPercentNewCarField?.value),
        dealerCommissionPercentUsedCar: Number(dealerCommissionPercentUsedCarField?.value)
    };
}

export function setDisclaimerFieldValueHandler(state, { key, value, changeAction, onChangeActions, options, }) {
    options;
    changeAction;
    
    state.disclaimerForm?.form?.forEach((form) => {
        const field = form.fields.find((f) => f.key === key);
        
        if (field) {
            if (field.type !== "dropdown") {
                field.value = value;
            }

            if (field.type === "dropdown") {
                field.value = value?.text;
                console.info(field.key, ' :: ', value?.text, value?.value)
            }
            
            field.hasError = false;
        }
    });
}

export function setDisclaimerIncrementFieldHandler(state, {key}) {
    console.log('key: ', key, state?.disclaimerForm)
    state?.disclaimerForm?.form?.forEach((form) => {
        const field = form?.fields?.find((f) => f.key === key);
        if (field) {
            console.log('key: ', field)
            field.keyReRender += 1;
        }
    });
}